import React, { createContext, useContext } from "react";
import { useFetch } from "@/hooks/useFetch";
import { useParams } from "react-router-dom";
import { contractKeys } from "components/contract/queries";
import { jobKeys } from "components/job/queries";
import { fetchContractJobsCount, fetchContractMeta } from "./api";

const ContractContext = createContext(null);

export const ContractProvider = ({ children }) => {
  const { contractId } = useParams();

  const {
    data: contract,
    isLoading: isContractLoading,
    isError: isContractError,
  } = useFetch({
    queryKey: contractKeys.meta(contractId),
    queryFn: () => fetchContractMeta({ contractId }),
  });

  const { data: ContractJobsCount, isLoading: ContractJobsCountLoading } =
    useFetch({
      queryKey: jobKeys.count(contractId),
      queryFn: () => fetchContractJobsCount({ contractId }),
    });

  return (
    <ContractContext.Provider
      value={{
        contract,
        ...contract,
        isContractLoading,
        isContractError,
        ContractJobsCount,
        ContractJobsCountLoading,
      }}
    >
      {children}
    </ContractContext.Provider>
  );
};

export const useContract = () => {
  const context = useContext(ContractContext);
  if (!context) {
    throw new Error(
      "useContractContext must be used within a ContractProvider"
    );
  }
  return context;
};
